export const contentDict = {
  title: "Rollbody: A Telepresence Robot",                // Display name
  finishDate: new Date("2022-08-30"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Python": 0.25,
    "ROS 2": 0.2,
    "C#": 0.1,
    "Unity": 0.2,
    "Java": 0.2,
    "Pizza": 0.05, 
  }, 
  description: 
    `Rollbody allows a remote operator wearing a VR headset to have an immersive telepresence experience.`,
  tags: ["Robotics", "VR"],
  github: "https://github.com/Roboy/rollbody/blob/main/all_code.md",    // Can also be `null`
  website: "https://roboy.github.io/rollbody/",       // Can also be `null`
  images: [
    'https://roboy.github.io/rollbody/static/videos/locomotion_720.mp4',
  ],
  coverImg: 'https://roboy.github.io/rollbody/static/videos/locomotion_720.mp4',
  mainColor: "#000",
  authors: ["Philipp Wulff", "Danylo Semerak", "Johannes Kirmayr", "Emin Vergili", "Deniz Seven", "Philipp Knestel", "Jefferson Chen", "Alona Kharchenko"],
  isResearch: false,    // Whether this should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }